export const SITE_NAME = 'AncestryHelp Online';
export const SITE_DOMAIN = 'ancestryhelp.online';
export const SITE_URL = 'https://ancestryhelp.online';
export const SITE_TAGLINE = 'Independent help for Ancestry family history users';
export const COMPANY_NAME = 'Nodex Global LLC';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS = `${ADDRESS_LINE1}, ${ADDRESS_LINE2}`;
export const POLICY_UPDATED = 'October 1, 2026';
export const META_DESCRIPTION =
  'Independent help for Ancestry users — sign-in and account issues, family tree fixes, DNA kit activation, app updates, syncing, and step-by-step troubleshooting guides, with 24/7 live chat.';

/** Support phone — shown next to Live Chat, in the footer and on the contact page. */
export const HELPS_PHONE = { display: '(844) 499-3050', tel: 'tel:+18444993050' };

export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_300149cda8b2b64caa0386e09898e3b6a7ef89673617e4c8';
export const LEAD_SOURCE = 'ancestryhelp';

/** Used in the legal pages so they describe the right software and trademark owners. */
export const PRODUCT_NAME = 'Ancestry';
export const TRADEMARK_OWNERS = 'Ancestry.com Operations Inc., Ancestry.com LLC';
